import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUserSettingsAddProjectPathBody } from '../../../../interface/interfaces';

interface IInitialState {
    defaultProjectPath: IUserSettingsAddProjectPathBody | null;
}

const initialState: IInitialState = {
    defaultProjectPath: null,
};

const defaultProjectPathSlice = createSlice({
    name: 'defaultProjectPath',
    initialState,
    reducers: {
        saveProjectPath: (state: IInitialState, action: PayloadAction<IUserSettingsAddProjectPathBody>) => {
            state.defaultProjectPath = null;
            state.defaultProjectPath = action.payload;
        },
        removeProjectPath: (state: IInitialState) => {
            state.defaultProjectPath = null;
        }
    },
});

export default defaultProjectPathSlice.reducer;
export const { saveProjectPath, removeProjectPath } = defaultProjectPathSlice.actions;
